"use client";

import { VolumeWindow } from "@decibeltrade/sdk";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { useDecibelWallet } from "@/hooks/use-decibel-wallet";

import { useWriteDexSdk } from "../write-dex-sdk-context";
import { accountOverviewQuery } from "./account-overview";
import { usdcBalanceQuery } from "./usdc-balance";

export function useWalletBalanceQuery() {
  const { accountAddress } = useDecibelWallet();

  return useQuery({
    ...usdcBalanceQuery({ accountAddr: accountAddress ?? "" }),
    enabled: !!accountAddress,
  });
}

export function useAccountBalanceQuery() {
  const { subaccountAddress } = useWriteDexSdk();

  const query = useQuery({
    ...accountOverviewQuery({
      subAddr: subaccountAddress ?? "",
      volumeWindow: VolumeWindow.ThirtyDays,
    }),
    enabled: !!subaccountAddress,
  });

  const mappedQuery = useMemo(
    () => ({
      ...query,
      data: query.data?.perp_equity_balance,
    }),
    [query],
  );

  return mappedQuery;
}
